var ctrlopt = ctrlopt;

(function ($) {
  var pCounterId,
    pAppointmentId,
    pToken,
    pStoreId,
    loc = window.parent.location !== window.location
      ? window.parent.location :
      window.location,
    nextSection = 'counters',
    apptBook = Drupal.appointmentBooking,
    modelSectionData = [
      {
        id: 'counters',
        jqElem: $('#counters')
      },
      {
        id: 'services',
        jqElem: $('#services')
      },
      {
        id: 'appointments',
        jqElem: $('#appointments')
      },
      {
        id: 'confirmation',
        jqElem: $('#confirmation')
      }
    ];
  var searchParams = new URLSearchParams(window.location.search);
  var pServicesId = searchParams.getAll('services_id');

  function getURLParam(oTarget, sVar) {
    return decodeURI(
      oTarget.search.replace(
        new RegExp(
          '^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$',
          'i'
        ),
        '$1'
      )
    );
  }

  pCounterId = getURLParam(loc, 'counter_id');
  pAppointmentId = getURLParam(loc, 'appointment_id');
  pToken = getURLParam(loc, 'token');
  pStoreId = getURLParam(loc, 'store_number');

  Drupal.behaviors.apptBook = {
    attach: function () {
      var updateObj,
        updateParams = null,
        hasCounters = false,
        hasServices = false,
        container = $('#appointment-book-container'),
        sectionsContainer = $('#appointment-book-sections'),
        sections = sectionsContainer.find('.appt-book-section'),
        sectionManager = apptBook.sectionManager.init(sectionsContainer, sections),
        mData = { data: modelSectionData },
        me = this;

      if (pToken) {
        mData.token = pToken;
      }

      function setCounters(data) {
        if (!data || !data.length) {
          window.location = '/';

          return;
        }
        hasCounters = true;
        if (hasServices) {
          run();
        }
      }

      function setServices() {
        hasServices = true;
        if (hasCounters) {
          run();
        }
      }

      function filterRequest(filterService, data) {
        var filterData = apptBook.sectionModel[filterService].filter(function (element) {
          return element.id === data;
        })[0];

        return filterData;
      }

      function run() {
        var currentSection, $header, $dots, $title, $subhead, isMobile;
        var isValidServiceAndCounter = false,
          serviceIds,
          counterById,
          serviceSelections = [],
          fltService;

        sectionManager.setModel(apptBook.sectionModel).startObserving();
        apptBook.historyHandler.setModel(apptBook.sectionModel).startObserving();

        if (pStoreId) {
          var foundCounterByNumber = apptBook.sectionModel.countersData.filter(function (element) {
            return element.store_no === pStoreId;
          })[0];

          if (foundCounterByNumber) {
            var counterService = apptBook.sectionModel.servicesData.filter(function (element) {
              return element.id === foundCounterByNumber.service_ids[0];
            })[0];

            if (counterService && counterService.virtual === '1') {
              Drupal.behaviors.apptBook.setVirtual('virtual_oab', 1);
            }
            pCounterId = foundCounterByNumber.id;
          }
        }

        if (pCounterId && pServicesId.length > 0) {
          counterById = filterRequest('countersData', pCounterId);
          if (counterById && pServicesId.length <= Number(counterById.max_appointment_services)) {
            serviceIds = counterById.service_ids;
            isValidServiceAndCounter = true;
            pServicesId.forEach(function (value) {
              if (jQuery.inArray(value, serviceIds) === -1) {
                isValidServiceAndCounter = false;
              }
            });
          }
          if (counterById && isValidServiceAndCounter) {
            pServicesId.forEach(function (value) {
              fltService = filterRequest('servicesData', value);
              if (fltService) {
                serviceSelections.push({
                  serviceId: fltService.id,
                  serviceDuration: fltService.total_duration,
                  serviceDurationWithPadding: fltService.total_duration_with_padding,
                  serviceName: fltService.name,
                  servicePrice: fltService.price,
                  subsequent: fltService.subsequent
                });
              }
            });
            nextSection = 'appointments';
            updateParams = {
              sectionId: nextSection,
              counterId: pCounterId,
              services: serviceSelections
            };
          }
        }

        if (pCounterId && !isValidServiceAndCounter) {
          counterById = filterRequest('countersData', pCounterId);
          if (counterById) {
            nextSection = 'services';
            updateParams = {
              sectionId: nextSection,
              counterId: pCounterId
            };
          }
        }

        if (pAppointmentId) {
          nextSection = 'appointments';
          updateParams = {
            appointmentId: pAppointmentId
          };
        }

        updateObj = {
          sectionId: nextSection,
          params: updateParams
        };

        // Subscribe to sectionModel update events and update the page header and the page indication dots
        apptBook.sectionModel.on('update', function (data) {
          var config = Drupal.settings.appointment_booking_main_collection,
            section = data.sectionId;

          if (section === currentSection) {
            return;
          }

          $header = $('.appt-book-page-header');
          $dots = $('.appt-book-page-header-content__dots', $header);
          $title = $('.appt-book-page-header-content__title', $header);
          $subhead = $('.appt-book-page-header-content__subhead', $header);
          // isMobile = Unison.fetch.now().name === 'small';
          isMobile = site.client.isMobile;

          if (isMobile) {
            $title = $('span', $title);
          }

          var s = {};

          for (var key in config) {
            if (!config.hasOwnProperty(key)) {
              continue;
            }

            s = config[key];
            if (s['section_key'] == section) {
              break;
            }
          }

          if (!$.isEmptyObject(s)) {
            if (s['section_key'] == 'confirmation') {
              $dots.hide();
            } else {
              $dots.show();
            }

            var i = s['section_number'];

            if (i.length > 0) {
              $('li', $dots)
                .removeClass('active')
                .filter('.dot--' + i)
                .addClass('active');
            } else {
              $('li', $dots).removeClass('active');
            }

            $title.html(s['section_title']);
            $subhead.html(s['section_subhead']);
          }

          currentSection = section;
        });

        apptBook.sectionModel.update(updateObj);
      }

      apptBook.sectionModel.on('data_set', function () {
        apptBook.sectionModel.off('data_set');
        apptBook.sectionModel.getCounters(setCounters);
        apptBook.sectionModel.getServices(setServices);
      });

      apptBook.sectionModel.setData(mData);
    },
    setVirtual: function (key, value) {
      localStorage.setItem(key, value);
    }
  };
})(jQuery);
